module.exports = __webpack_public_path__ + "img/privacy_person_full.005cadab.png";